import { EventCardListing } from 'components/eventCard/eventCardListing'
import { BulkTicketControls } from 'components/ticket/bulkTicketControls'
import { SeatTicketControls } from 'components/ticket/seatTicketControls'
import { Container, PageTitle } from 'components/ticket/ticket.style'
import { useTickets } from 'hooks/user/useTickets'
import { useTicketStatusesInterval } from 'hooks/user/useTransactionStatus' // <-- import the shared hook
import { useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { EventDetails } from 'types/Event'

interface Props {
    currentEvent: EventDetails
}

export const DownloadLocalTickets = ({ currentEvent }: Props) => {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const selectedSeats = queryParams.get('seats')?.split(',') ?? []
    const { eventId } = useParams<{ eventId: string }>()

    const { areAllTicketsSold } = useTicketStatusesInterval(selectedSeats, eventId!)

    const { handlePrintTicket, handleDownloadTicket, handlePrintAllTickets, handleDownloadAllTickets } = useTickets(
        currentEvent,
        selectedSeats,
    )

    const [activeLoadingKey, setActiveLoadingKey] = useState<string | null>(null)

    return (
        <Container>
            {currentEvent && selectedSeats.length > 0 ? (
                <>
                    <PageTitle>Jegyek</PageTitle>
                    {currentEvent.event_id && <EventCardListing eventId={currentEvent.event_id} showPurchaseButton={false} />}
                    <SeatTicketControls
                        currentEvent={currentEvent}
                        selectedSeats={selectedSeats}
                        activeLoadingKey={activeLoadingKey}
                        setActiveLoadingKey={setActiveLoadingKey}
                        handlePrintTicket={handlePrintTicket}
                        handleDownloadTicket={handleDownloadTicket}
                        areAllTicketsSold={areAllTicketsSold}
                    />
                    <BulkTicketControls
                        activeLoadingKey={activeLoadingKey}
                        setActiveLoadingKey={setActiveLoadingKey}
                        handlePrintAllTickets={handlePrintAllTickets}
                        handleDownloadAllTickets={handleDownloadAllTickets}
                        areAllTicketsSold={areAllTicketsSold}
                    />
                </>
            ) : (
                <div>{!currentEvent ? 'No event found.' : 'No seats selected.'}</div>
            )}
        </Container>
    )
}
